import React, {useState, useMemo, useContext} from "react";
import TrainerLayout from "./TrainerLayout";
import TrainerAccountDetails from "./TrainerAccountDetails";
import TrainerWorkingHoursContent from "./TrainerWorkingHoursContent";
import { isOwner } from "../../utils/trainerRoleUtils";
import "../../styles/Tabs.css";
import "../../styles/AccountDetails.css";
import "../../styles/TrainerWorkingHours.css";
import SubscriptionTab from "../subscription/SubscriptionTab";
import {TrainerContext} from "../../context/TrainerContext";

const TrainerAccount = () => {
    const [activeTab, setActiveTab] = useState("account");
    const { trainer } = useContext(TrainerContext);

    // Get current user's role in their school
    const currentUserRole = trainer?.trainerSchoolRole;

    // Build tabs based on user role
    const tabs = useMemo(() => {
        const baseTabs = [
            { key: "account", label: "Dane konta" },
            { key: "workingHours", label: "Godziny" }
        ];

        // Only show subscription tab for School Owners
        if (isOwner(currentUserRole)) {
            baseTabs.push({ key: "subscription", label: "Subskrypcja" });
        }

        return baseTabs;
    }, [currentUserRole]);

    const renderTabContent = () => {
        switch (activeTab) {
            case "account":
                return <TrainerAccountDetails />;
            case "workingHours":
                return <TrainerWorkingHoursContent />;
            case "subscription":
                // Double-check role before rendering (safety measure)
                return isOwner(currentUserRole) ? <SubscriptionTab /> : <TrainerAccountDetails />;
            default:
                return <TrainerAccountDetails />;
        }
    };

    return (
        <TrainerLayout>
            <div className="trainer-account-container">
                {/* Tab Navigation - using Tabs.css classes */}
                <div className="tabs-nav" style={{ marginBottom: 0 }}>
                    {tabs.map((tab) => (
                        <button
                            key={tab.key}
                            className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div style={{ paddingTop: '20px' }}>
                    {renderTabContent()}
                </div>
            </div>
        </TrainerLayout>
    );
};

export default TrainerAccount;